export default __webpack_public_path__ + "static/media/23.3776db91.webp";